// extracted by mini-css-extract-plugin
export default {"rpgGameClanBase":"RPGGameClanBase_rpgGameClanBase__cT+px"};